import { Link } from "wouter";
import { MessageCircle, Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { GoldParticles } from "@/components/ui/GoldParticles";
import { HAS_WHATSAPP, getWhatsAppLink, getWhatsAppDisplayNumber } from "@/lib/contactConfig";

interface ContactCTAProps {
  t: (key: string) => string;
}

const EMAIL = "contact@aurelianprivatecare.com";

export function ContactCTA({ t }: ContactCTAProps) {
  return (
    <section
      className="relative py-24 overflow-hidden bg-gradient-to-br from-foreground via-foreground/95 to-primary/20 text-background"
      data-testid="section-contact"
      id="section-contact"
    >
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <GoldParticles />
      </div>
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2
          className="text-3xl md:text-4xl font-serif font-bold mb-4"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {t("contact.title")}
        </h2>
        <p className="text-lg text-background/90 mb-10">{t("contact.subtitle")}</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-10">
          {HAS_WHATSAPP && (
            <a
              href={getWhatsAppLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-5 py-3 rounded-xl border border-background/30 hover:bg-background/10 transition-colors"
            >
              <MessageCircle className="w-5 h-5" aria-hidden />
              <span>WhatsApp</span>
              <span className="text-background/80 text-sm">{getWhatsAppDisplayNumber()}</span>
            </a>
          )}
          <Link href="/evaluation">
            <span className="flex items-center gap-3 px-5 py-3 rounded-xl border border-background/30 hover:bg-background/10 transition-colors cursor-pointer">
              <MessageCircle className="w-5 h-5" aria-hidden />
              {t("contact.chat")}
            </span>
          </Link>
          <a
            href={`mailto:${EMAIL}`}
            className="flex items-center gap-3 px-5 py-3 rounded-xl border border-background/30 hover:bg-background/10 transition-colors"
          >
            <Mail className="w-5 h-5" aria-hidden />
            Email
            <span className="text-background/80 text-sm truncate max-w-[180px]">{EMAIL}</span>
          </a>
        </div>

        <Link href="/evaluation">
          <Button
            size="lg"
            className="bg-primary text-primary-foreground hover:bg-primary/90 min-h-12 px-8 text-base"
          >
            {t("contact.cta")}
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>
    </section>
  );
}
